import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase'
import 'firebase/firestore'

Vue.use(firestorePlugin)

export default firebase.initializeApp({
	apiKey: "AIzaSyD05E7t3RRWKjYBmX7FBxBqi8lmAUMgohI",
	authDomain: "jitube.firebaseapp.com",
	databaseURL: "https://jitube.firebaseio.com",
	projectId: "jitube",
	storageBucket: "jitube.appspot.com",
	messagingSenderId: "1040702464799",
	appId: "1:1040702464799:web:14071cdcd9982cb3"
}).firestore()
